import { lazy } from "react";
const TrainMap = lazy(() => import("./map"));

export const Suspend = () => {
  return <TrainMap />;
};

export default Suspend;
